import { render, staticRenderFns } from "./modalMedio.vue?vue&type=template&id=90a21e18&"
import script from "./modalMedio.vue?vue&type=script&lang=js&"
export * from "./modalMedio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports